/* eslint-disable react/no-children-prop */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

const Typography = ({
  variant,
  children,
  color,
  className,
  font,
  ...props
}) => {
  const variantMapping = {
    h1: {
      variant: "h1",
      classes:
        "font-lato_bold 2xl:text-3xl  md:text-xl text-base   leading-normal ",
    },
    h2: {
      variant: "h2",
      classes: "font-lato_bold 2xl:text-4xl font-bold   lg:text-2xl text-xl ",
    },
    h3: {
      variant: "h3",
      classes:
        "font-lato_semibold 2xl:text-3xl lg:text-2xl md:text-xl texl-lg font-bold md:text-base text-sm  ",
    },
    h4: {
      variant: "h4",
      classes:
        "font-lato_medium 2xl:text-[32px]  lg:text-xl font-bold sm:text-lg text-lg    ",
    },
    h5: {
      variant: "h5",
      classes:
        "font-lato_medium 2xl:text-2xl md:text-lg sm:text-base text-sm  font-medium ",
    },
    h6: {
      variant: "h6",
      classes: "font-lato_medium 2xl:text-xl  lg:text-base text-sm font-medium",
    },
    p: {
      variant: "p",
      classes:
        "font-lato_regular 2xl:text-lg xl:text-base md:text-sm  text-xs   font-medium",
    },
    p1: {
      variant: "p",
      classes:
        "font-lato_regular 2xl:text-base md:text-sm text-xs  font-regular ",
    },
    p2: {
      variant: "p",
      classes: "font-lato_regular 2xl:text-sm text-xs  font-regular ",
    },
  };
  const colors = {
    primary: "",
    secondary: "",
    dark: "",
    light: "",
  };

  const classes = variantMapping[variant]?.classes || "";
  const Component = variantMapping[variant]?.variant || "p";
  const colorClass = colors[color];

  return (
    <Component
      className={`   ${classes} ${colorClass} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

Typography.propTypes = {
  variant: PropTypes.oneOf([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "p1",
    "p2",
  ]).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Typography.defaultProps = {
  className: "",
  variant: "p",
};

export default Typography;
